import type { ComponentType } from 'react'
import type { DocMeta } from '@/content/docs.generated'
import { ALL_DOCS } from '@/content/docs.generated'

/**
 * Lazy MDX loading.
 *
 * `import.meta.glob` gives Vite a static list of every document at build time,
 * so each becomes its own chunk. 40 documents inlined into the main bundle
 * would be ~35,000 words of dead weight on the homepage.
 */
type MdxModule = { default: ComponentType; frontmatter?: Record<string, unknown> }

const posts = import.meta.glob<MdxModule>('/src/content/posts/**/*.mdx')
const support = import.meta.glob<MdxModule>('/src/content/support/**/*.mdx')

/** Resolve a route like `/post/singulate-sandbox` to its MDX loader. */
export function loadDoc(route: string): (() => Promise<MdxModule>) | null {
  const doc = ALL_DOCS.find((d) => d.route === route)
  if (!doc) return null
  const dir = doc.kind === 'post' ? 'posts' : 'support'
  return posts[`/src/content/${dir}/${doc.slug}.mdx`] ?? support[`/src/content/${dir}/${doc.slug}.mdx`] ?? null
}

export function findDoc(route: string): DocMeta | undefined {
  return ALL_DOCS.find((d) => d.route === route)
}

/** Every MDX path Vite knows about — used to verify the index matches disk. */
export const KNOWN_MDX = [...Object.keys(posts), ...Object.keys(support)]
